import { Fragment, memo } from 'react';
import CivilStatus from '../shared/civil-status';
import EditData from '../shared/edit-data';
import Marriage from './marriage';
import AccordionPerson from 'shell/components/shared/person';

interface RegistrationMarriageNonResidentProps {
  editSipoUrl?: string;
}

const RegistrationMarriageNonResidentComponent = ({
  editSipoUrl,
}: RegistrationMarriageNonResidentProps): React.ReactElement => {
  return (
    <Fragment>
      <AccordionPerson disabled />
      <EditData />
      <CivilStatus disabled />
      <Marriage editSipoUrl={editSipoUrl} />
    </Fragment>
  );
};

RegistrationMarriageNonResidentComponent.displayName =
  'Registration Marriage Non resident component';

const RegistrationMarriageNonResident = memo(RegistrationMarriageNonResidentComponent);

export default RegistrationMarriageNonResident;
